export default __webpack_public_path__ + "static/media/practice_show.91e23753.png";